module.exports = __webpack_public_path__ + "static/media/main1_en_768-min.4ade8488.png";